module.exports = function () {
    $('.banner-carousel').slick();
};
